module.exports = __webpack_public_path__ + "img/Talk Graphic 2 - Advice from Techpreneur.e40cdda8.png";